import {
  Container,
  Title,
  Text,
  Button,
  Group,
  Box,
  Stack,
  Image,
  Paper,
  Center,
  Loader,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../hooks/useAuth';

export default function Home() {
  const { t } = useTranslation();
  const { login, isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <Center h="100vh">
        <Loader size="lg" />
      </Center>
    );
  }

  if (isAuthenticated) {
    return (
      <Navigate
        to={user?.approved ? '/app' : '/app/pending-approval'}
        replace
      />
    );
  }

  return (
    <Box>
      {/* Hero Section */}
      <Box
        style={{
          background: '#F5F7FB',
          padding: '80px 20px',
          textAlign: 'center',
          color: '#1a1a1a',
          marginTop: 70,
        }}
      >
        <Container size="md">
          <Image
            src="/strassenwaechter-logo.png"
            alt="Straßenwächter e.V."
            height={160}
            fit="contain"
            mx="auto"
            mb="lg"
          />
          <Title order={1} size="h1" mb="md" style={{ color: '#1a1a1a' }}>
            {t('home.title')}
          </Title>
          <Text size="lg" style={{ color: '#555555' }} mb="xl">
            {t('home.subtitle')}
          </Text>

          <Group justify="center" gap="md">
            <Button
              component="a"
              href="/volunteer/register"
              variant="filled"
              size="lg"
              style={{
                backgroundColor: '#3DA5D9',
                color: 'white',
                fontWeight: 600,
              }}
            >
              {t('home.registerButton')}
            </Button>
            <Button
              onClick={login}
              variant="outline"
              size="lg"
              style={{
                backgroundColor: 'transparent',
                color: '#3DA5D9',
                border: '2px solid #3DA5D9',
              }}
            >
              {t('home.login')}
            </Button>
          </Group>
        </Container>
      </Box>

      {/* Info Section */}
      <Container size="md" py="xl">
        <Stack gap="lg">
          <Paper p="lg" radius="md" style={{ backgroundColor: '#f8f9fa' }}>
            <Title order={2} mb="md" style={{ color: '#3DA5D9' }}>
              {t('home.about')}
            </Title>
            <Text>{t('home.description')}</Text>
          </Paper>
        </Stack>
      </Container>
    </Box>
  );
}
